module.exports = __webpack_public_path__ + "img/server4-1.43618c3c.png";